module.exports = __webpack_public_path__ + "img/3.445419b0.png";